import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import ThemeToggle from "../../theme/ThemeToggle";
import "./Navbar.css";

const Navbar = ({ logo, currentPage, menuItems }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  const handleMenuToggle = () => setMenuOpen((open) => !open);
  const handleMenuItemClick = () => setMenuOpen(false);

  // Close menu on outside click, but allow clicking the hamburger to always toggle
  useEffect(() => {
    if (!menuOpen) return;
    function handleClickOutside(event) {
      // If click is on the hamburger button, let it toggle as normal
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        !event.target.closest('.navbar-hamburger')
      ) {
        setMenuOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [menuOpen]);

  return (
    <nav className="navbar">
      <div className="navbar-left">
        <Link
          to="/"
          className="navbar-logo-link"
          style={{
            display: "flex",
            alignItems: "center",
            textDecoration: "none",
          }}
        >
          <img
            src={process.env.PUBLIC_URL + "/{JO}.svg"}
            alt="Backendia Logo"
            className="navbar-logo"
          />
          <div className="navbar-brand-block">
            <span className="navbar-brand-text">
              Backendia — The Realm of Code
            </span>
            <span className="navbar-brand-subtitle">
              Where code is conjured & systems obey.
            </span>
          </div>
        </Link>
      </div>
      <button
        className={`navbar-hamburger${menuOpen ? " open" : ""}`}
        aria-label={menuOpen ? "Close menu" : "Open menu"}
        aria-expanded={menuOpen}
        onClick={handleMenuToggle}
        type="button"
      >
        <span />
        <span />
        <span />
      </button>
      <div ref={menuRef} className={`navbar-right${menuOpen ? " open" : ""}`}>
        {menuItems &&
          menuItems.map((item) =>
            item.href && !item.disabled ? (
              <Link
                key={item.label}
                to={item.href}
                className={`navbar-link${
                  item.label === currentPage ? " navbar-link-active" : ""
                }`}
                onClick={handleMenuItemClick}
              >
                {item.label}
              </Link>
            ) : (
              <button
                key={item.label}
                className={`navbar-link${
                  item.label === currentPage ? " navbar-link-active" : ""
                } navbar-link-disabled`}
                disabled={item.disabled}
                style={{ pointerEvents: "none", opacity: 0.5 }}
                onClick={handleMenuItemClick}
              >
                {item.label}
              </button>
            )
          )}
        <ThemeToggle />
      </div>
    </nav>
  );
};

export default Navbar;
